import { render } from "./SuperAdminSlowQueries.vue?vue&type=template&id=1b076e1d&scoped=true"
import script from "./SuperAdminSlowQueries.vue?vue&type=script&lang=js"
export * from "./SuperAdminSlowQueries.vue?vue&type=script&lang=js"

import "./SuperAdminSlowQueries.vue?vue&type=style&index=0&id=1b076e1d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b076e1d"]])

export default __exports__